import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  output,
  signal,
} from '@angular/core';
import { DropdownEvent, DropdownItem } from '@shared/abstraction';
import { SecurityStatus } from '@shared/enums/security-status';
import { parseTo } from '@shared/helpers/utils';
import { taxResultStatusItems } from 'src/app/modules/tax-result/constants/tax-result-status-items';

@Component({
  standalone: false,
  selector: 'gstar-tax-result-status-dropdown',
  templateUrl: './tax-result-status-dropdown.component.html',
  styleUrl: './tax-result-status-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxResultStatusDropdownComponent {
  taxResultStatusItems = signal<DropdownItem[]>(taxResultStatusItems);
  selected = signal<DropdownItem>(taxResultStatusItems[0]);

  selectItem = output<KeyValue<string, SecurityStatus>>();

  onSelectFilterItem(event: DropdownEvent): void {
    this.selectItem.emit(
      parseTo<KeyValue<string, SecurityStatus>>(event.selected)
    );
  }
}
